import { useSystemCoin } from '@/hooks/theme/useSystemCoin';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import ValueWithCoinCell from '../ValueWithCoinCell';
import { WithResolvedThemeCoinCellProps } from './props';

export default function WithResolvedThemeCoinCell({
  value,
}: WithResolvedThemeCoinCellProps) {
  const coin = useSystemCoin();

  return (
    <ValueWithCoinCell
      coin={coin}
      value={WalletService.maskCurrency({
        amount: getMoneyOrAmount(value),
        coin,
      })}
    />
  );
}
